import { TGetContactDetailResDto } from "@/api/services/admin/contact/dtos/get-contact-detail.dto";
import { FileItem } from "@/components/elements/FileItem";
import { Input } from "@/components/elements/Input";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { Textarea } from "@/components/elements/Textarea";
import { EMPTY_STR } from "@/constants/string";
import { FCC } from "@/types/common";
import { parseFilePath } from "@/utils/file";
import { Grid, Stack, Typography } from "@mui/material";

type TContactInfoProps = {
  isLoading: boolean;
  data?: TGetContactDetailResDto;
};

export const ContactInfo: FCC<TContactInfoProps> = ({ isLoading, data }) => {
  if (isLoading) return <LoadingPage />;

  const files = parseFilePath(data?.data.filePath);

  return (
    <Stack gap={2}>
      <Stack gap={2}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Stack gap={1}>
              <Typography variant="body14">お客様の企業名</Typography>
              <Input size="lg" value={data?.data.match?.matchName} readonly />
            </Stack>
          </Grid>
          <Grid item xs={8}></Grid>
          <Grid item xs={4}>
            <Stack gap={1}>
              <Typography variant="body14">担当者名</Typography>
              <Input size="lg" value={data?.data.user?.fullName} readonly />
            </Stack>
          </Grid>
          <Grid item xs={8}></Grid>
          <Grid item xs={4}>
            <Stack gap={1}>
              <Typography variant="body14">お問い合わせの種類</Typography>
              <Input size="lg" value={data?.data.contactType.name} readonly />
            </Stack>
          </Grid>
          <Grid item xs={8}></Grid>
          <Grid item xs={12}>
            <Stack gap={1}>
              <Typography variant="body14">お問い合わせ内容の詳細</Typography>
              <Textarea readonly value={data?.data.content} />
            </Stack>
          </Grid>

          {files.length > 0 && (
            <>
              <Grid item xs={6}>
                <Stack gap={1}>
                  <Typography variant="body14">添付ファイル</Typography>
                  {files.map((file, idx) => (
                    <FileItem key={idx} filePath={file.path} downloadable />
                  ))}
                </Stack>
              </Grid>
              <Grid item xs={6}></Grid>
            </>
          )}

          <Grid item xs={4}>
            <Stack gap={1}>
              <Typography variant="body14">メールアドレス</Typography>
              <Input size="lg" value={data?.data.email} readonly />
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack gap={1}>
              <Typography variant="body14">連絡先電話番号</Typography>
              <Input size="lg" value={data?.data.telNumber || EMPTY_STR.TEXT} readonly />
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
